import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { ModalDialog } from 'components/ModalDialog';
import type { PriceListRatioCoefficientRowData } from 'gql/graphql';

import type React from 'react';

import { useRatioUersColumns } from './hooks/useRatioUersColumns';
import { useUerPriceListRatioUerRows } from './hooks/useUerPriceListRatioUerRows';

import Style from './RatioUers.module.css';

interface IRatioUers {
    onClose: () => void;
    ratio: PriceListRatioCoefficientRowData;
}

const modalStyle = { width: 1136 };

export const RatioUers: React.FC<IRatioUers> = (props) => {
    const { onClose, ratio } = props;

    const { columns, filterValues } = useRatioUersColumns(ratio.id);
    const { dataSource } = useUerPriceListRatioUerRows(ratio.id, filterValues);

    return (
        <ModalDialog
            title={`Расценки к Коэффициенту ${ratio.code}`}
            isOpen
            hasOverlay
            withTitleCloseButton
            isOnClickOutsideDisable
            onClose={onClose}
            btnCancelLabel="Закрыть"
            btnCancelView="primary"
            style={modalStyle}
        >
            <div className={Style.ratioUersBody}>
                <AgGridTable
                    maxConcurrentDatasourceRequests={1}
                    maxBlocksInCache={50}
                    cacheBlockSize={50}
                    rowModelType="infinite"
                    columnDefs={columns}
                    datasource={dataSource}
                />
            </div>
        </ModalDialog>
    );
};

RatioUers.displayName = 'RatioUers';
